var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":_vm.title,"items":_vm.items,"doc":_vm.doc}},[_c('div',{staticClass:"s-vstack my-3"},[_c('Info'),_c('div',{staticClass:"link-box"},[_c('Download'),_c('SortModifiers')],1),_c('BizTaxRates'),_c('Integration')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }